import { registerMockAPI } from '~/mocks/mockApis';

import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';
import { transformToSelectOptions } from '~/utils/common';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { GetCollectingRequestRegisterOptionsResponse } from '~/types/delivery-agency.types';

const fetchCollectingRequestRegisterOptions = async () => {
  const { data } = await axiosInstance.get<GetCollectingRequestRegisterOptionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_COLLECTING_REQUEST_REGISTER_OPTIONS
  );
  return data.data;
};

export const useGetCollectingRequestRegisterOptionsQuery = (options?: {
  enabled?: boolean;
  showGlobalErrorToast?: boolean;
}) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.collectingRequestRegisterOptions(),
    queryFn: fetchCollectingRequestRegisterOptions,
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 30,
    meta: { showGlobalErrorToast: options?.showGlobalErrorToast ?? true },
    select: (data) => ({
      deliveryLocations: transformToSelectOptions(data.deliveryLocations, 'code', 'description'),
      entranceMethods: transformToSelectOptions(data.entranceMethods, 'code', 'description'),
      collectedProductHandlings: transformToSelectOptions(data.collectedProductHandling, 'code', 'description'),
    }),
  });
};

registerMockAPI<GetCollectingRequestRegisterOptionsResponse>({
  method: 'get',
  endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_COLLECTING_REQUEST_REGISTER_OPTIONS,
  label: '배송 주문 반품 신청·조회/반품 신청 회수 정보 옵션',
  scenarios: [
    {
      name: '정상 응답',
      response: {
        data: {
          deliveryLocations: [
            { code: 'DOORSTEP', description: '문 앞' },
            { code: 'DELIVERY_BOX', description: '택배 수령실' },
            { code: 'PUBLIC_DOOR', description: '공동현관(대문) 앞' },
            { code: 'ETC', description: '기타' },
          ],
          entranceMethods: [
            { code: 'PUBLIC_DOOR_PWD', description: '공동현관 비밀번호' },
            { code: 'CALL_SECURITY', description: '경비실 호출' },
            { code: 'FREE_ACCESS', description: '자유출입' },
            { code: 'ETC', description: '기타' },
          ],
          collectedProductHandling: [
            { code: 'DISPOSE', description: '배송사폐기' },
            { code: 'RETURN_TO_SENDER', description: '다시 돌려받기(반송)' },
          ],
        },
      },
    },
  ],
});
